<template>
  <Transition
    enter-active-class="transition duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)]"
    enter-from-class="scale-0 opacity-0"
    enter-to-class="scale-100 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="scale-100 opacity-100"
    leave-to-class="scale-0 opacity-0"
    mode="out-in"
  >
    <button
      v-if="!isOpen"
      key="open"
      class="fixed bottom-6 right-6 z-[60] flex h-16 w-16 items-center justify-center rounded-full bg-foreground text-background shadow-lg transition-all hover:scale-105 hover:bg-foreground/90 hover:shadow-xl active:scale-95"
      :aria-label="$ts('support.chat.open')"
      @click="$emit('toggle')"
    >
      <Icon name="tabler:message-circle" size="26" />
    </button>
    <button
      v-else
      key="close"
      class="fixed bottom-6 right-6 z-[60] hidden h-16 w-16 items-center justify-center rounded-full bg-muted text-muted-foreground shadow-lg transition-all hover:scale-105 hover:bg-muted/80 active:scale-95 sm:flex"
      :aria-label="$ts('support.chat.open')"
      @click="$emit('toggle')"
    >
      <Icon name="tabler:x" size="26" />
    </button>
  </Transition>
</template>

<script setup lang="ts">
import { useI18n } from '#imports';

const { $ts } = useI18n();

defineProps<{
  isOpen: boolean;
}>();

defineEmits<{
  toggle: [];
}>();
</script>
